import ComingSoon from '../../components/common/ComingSoon';
import { Images } from '../../utils/imageConstants';

const LiveStreamingComingSoon = () => (
  <ComingSoon
    logoSrc={Images.main_logo}
    headline="Live Streaming Feature Coming Soon..."
    description="This feature is under development and will be available soon.
Stay tuned!"
  />
);

export default LiveStreamingComingSoon;
